// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"28de74ea","554":"28de74ea"}[chunkId] + ".chunk.css";
};